module.exports = __webpack_public_path__ + "static/img/mobilehead.1c931282.png";